<template>
  <div class="performance_container">
    <div class="open_app video_app d-f jc-sb ai-c">
      <img src="../../assets/images/detail/logo.png" alt="" />
      <span class="content_app">打开文化广东APP，查看详情内容</span>
      <div class="open_btn" @click="openApp">立即打开</div>
    </div>
    <div class="swiper">
      <!-- <img src="@/assets/images/detail/back_white.png" alt="" class="back" @click="back" /> -->
      <van-swipe>
        <van-swipe-item> <img :src="detailInfo.picUrl" alt="" class="swiper_img" /> </van-swipe-item>
        <!-- <template #indicator>
          <div class="custom-indicator">{{ current + 1 }}/5</div>
        </template> -->
      </van-swipe>
    </div>
    <!-- <img src="@/assets/images/detail/performance/color_bg.png" alt="" class="top_bg" /> -->
    <!-- <div class="navbar">
      <span>活动详情</span>
      <img src="@/assets/images/detail/back.png" alt="" class="back" @click="back" />
    </div> -->
    <div class="main_card">
      <!-- <div class="card_detail d-f">
        <div class="pic_box">
          <div class="view_box d-f ai-c">
            <img src="../../assets/images/detail/eye.png" alt="" class="eye_icon" />
            <span>{{ detailInfo.pageViewNum }}</span>
          </div>
          <img :src="detailInfo.picUrl" alt="" class="pic_url" />
        </div>
        <div class="card_title">
          <span class="common_title">{{ detailInfo.name }}</span>
          <div class="sub_title">
            <span>{{ detailInfo.typeName }}</span
            ><span>{{ detailInfo.applyNumber }}/{{ detailInfo.maxNumber }}</span>
          </div>
        </div>
      </div> -->
      <div class="card_info d-f fxd-c">
        <div class="common_title">{{ detailInfo.name }}</div>
        <div class="sub_title d-f jc-sb ai-c">
          <span>{{ detailInfo.typeName }}</span
          ><span> 票数：{{ detailInfo.applyNumber }}/{{ detailInfo.maxNumber }}</span>
        </div>
        <div class="info_item d-f ai-c" v-if="detailInfo.regStartDay">
          <img src="@/assets/images/detail/performance/date.png" alt="" />
          <div>报名时间：{{ detailInfo.regStartDay }}-{{ detailInfo.regEndDay }}</div>
        </div>
        <div class="info_item d-f ai-c">
          <img src="@/assets/images/detail/performance/date.png" alt="" />
          <div>活动时间：{{ detailInfo.startDay }}-{{ detailInfo.endDay }}</div>
        </div>
        <div class="info_item d-f ai-c">
          <img src="@/assets/images/detail/performance/address.png" alt="" />
          <div>主办单位：{{ detailInfo.unitName }}</div>
        </div>
        <div class="info_item d-f ai-c" v-if="detailInfo.address">
          <img src="@/assets/images/detail/performance/location.png" alt="" />
          <div>活动地址：{{ detailInfo.address }} I {{ detailInfo.distance |  }}km</div>
          <img src="@/assets/images/detail/performance/navigation.png" @click="openApp" alt="" class="icon" />
        </div>
        <div class="info_item d-f ai-c">
          <img src="@/assets/images/detail/performance/people.png" alt="" />
          <div>联系人：{{ detailInfo.linkman }}</div>
        </div>
        <div class="info_item d-f ai-c" @click="arousePhone(detailInfo.phone)">
          <img src="@/assets/images/detail/performance/call.png" alt="" />
          <div>联系电话：{{ detailInfo.phone }}</div>
          <img src="@/assets/images/detail/performance/phone.png" alt="" class="icon" />
        </div>
      </div>
      <div class="tips" v-if="detailInfo.remark">
        <div class="common_title">温馨提示</div>
        <div class="content">
          {{ detailInfo.remark }}
        </div>
      </div>
      <div class="event_profile" v-if="detailInfo.detail">
        <div class="common_title">活动简介</div>
        <div class="content" v-html="detailInfo.detail"></div>
      </div>

      <div class="handle_button d-f jc-sb ai-c">
        <div class="handle_item d-f ai-c border_right" @click="openApp">
          <img src="@/assets/images/detail/performance/circle_share.png" alt="" class="icon_handle" />
          <span style="white-space: pre-wrap; display: inline-block; width: 30px">分享</span>
        </div>
        <div class="btn" :class="detailInfo.status == 0 ? '' : 'disabled'" @click="openApp">{{ signStatus[detailInfo.status] }}</div>
      </div>
      <!-- <div class="summit_button">
        <div class="btn" :class="detailInfo.status == 0 ? '' : 'disabled'" @click="signUp">{{ signStatus[detailInfo.status] }}</div>
      </div> -->
    </div>
    <van-dialog
      v-model="dialogShow"
      title="请先下载客户端"
      show-cancel-button
      confirmButtonText="立即下载"
      confirmButtonColor="#A97048"
      cancelButtonText="我知道了"
      @confirm="dialogConfirm"
      @cancel="dialogCancel"
    >
      <div class="content_dialog">下载APP后查看完整内容</div>
    </van-dialog>
    <!-- <van-share-sheet title="分享到" v-model="showShare" :options="shareOptions" @select="onSelect" /> -->
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { getActivityDetails } from '@/api/activity.js'
import config from '@/utils/config.js'
import { getToken, getVenueToken } from '@/utils/auth'
export default {
  data() {
    return {
      queryData: {},
      showShare: false,
      detailInfo: {},
      signStatus: ['立即报名', '即将开始', '无需报名', '名额已满', '报名结束'],
      shareUrl: config.shareUrl,
      dialogShow: false,
      isAndroid: false,
      isIos: false,
      schemeUrl: '',
      downloadUrl: 'https://www.pgyer.com/ghjCEr',
    }
  },
  computed: {
    ...mapGetters(['shareOptions']),
  },
  created() {
    // 判断是ios还是android  在created的时候调用
    var u = navigator.userAgent,
      app = navigator.appVersion
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)

    if (isAndroid) {
      this.isAndroid = true
      this.schemeUrl = `culturalgd://pages/spread/index?id=${this.queryData.id}` //安卓 通过配置的schemes 打开已经安装的app
      // this.downloadUrl = `index.html#${curRoute}` //静态下载页
    }
    if (isIOS) {
      this.isIos = true
      this.schemeUrl = `culturalgdios://pages/spread/index?id=${this.queryData.id}` //ios 通过配置的urlschemes 打开已经安装的app
      // this.downloadUrl = `index.html#${curRoute}` //静态下载页
    }
  },
  mounted() {
    console.log('this.$route=============>', this.$route.query)
    const { id } = this.$route.query
    this.queryData = { id, latitude: '', longitude: '' }
    this.getDetail()
  },
  methods: {
    UNInavigation() {
      this.$myUni.postMessage({
        data: {
          methodsName: 'UNInavigation',
          data: {
            name: this.detailInfo.address,
            latitude: this.queryData.latitude,
            longitude: this.queryData.longitude,
          },
        },
      })
    },
    share() {
      if (getToken()) {
        this.showShare = true
      } else {
        this.$myUni.navigateTo({
          url: '/pages/login/index',
        })
      }
    },
    openApp() {
      // window.location.href = this.schemeUrl
      this.dialogShow = true
    },
    dialogCancel() {},
    dialogConfirm() {
      window.location.href = 'https://www.pgyer.com/ghjCEr'
    },
    getDetail() {
      getActivityDetails(this.queryData).then((res) => {
        console.log(res)
        this.detailInfo = res.result
      })
    },
    signUp() {
      console.log(this.detailInfo.status)
      if (this.detailInfo.status == 0) {
        const { id, name } = this.detailInfo
        this.$router.push({
          path: '/detail/activityRegistration',
          query: {
            id,
            name,
          },
        })
      }
    },
    back() {
      this.$myUni.navigateBack({
        delta: 1,
      })
    },
    arousePhone(phone) {
      window.location.href = `tel:${phone}`
    },
    onSelect(option) {
      console.log('option====>', option)
      const url = `${this.shareUrl}/share/performance?id=${this.queryData.id}`
      this.$myUni.postMessage({
        data: {
          methodsName: 'UNIShare',
          UNISharedata: {
            // 微信好友 朋友圈 QQ好友 复制链接
            shareType: option.name,
            shareUrl: url,
            id: this.queryData.id,
            title: this.detailInfo.name,
            subTitle: '',
            picUrl: this.detailInfo.picUrl,
          },
        },
      })
      // if (option.name == '复制链接') {
      //   this.handleShare(url)
      // } else if (option.name == '微信好友') {

      // }
      this.showShare = false
    },
    // handleShare(item) {
    //   console.log('复制链接')
    //   // 创建模拟 输入框
    //   var cInput = document.createElement('input')
    //   cInput.value = item
    //   document.body.appendChild(cInput)
    //   cInput.select() // 选取文本框内容
    //   // 执行浏览器复制命令
    //   // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
    //   // Input要在正常的编辑状态下原生复制方法才会生效
    //   document.execCommand('copy')
    //   this.$cue.toast('已复制链接')

    //   // 复制成功后再将构造的标签 移除
    //   document.body.removeChild(cInput)
    // },
  },
}
</script>
<style lang="scss" scoped>
.performance_container {
  height: 100vh;
  // background: #47988aff;
  background: #fff;
  // padding-top: 4px;
  // .top_bg {
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  //   width: 100%;
  //   height: 12rem;
  // }

  // .navbar {
  //   z-index: 10;
  //   width: 100%;
  //   height: 44px;
  //   position: fixed;
  //   top: 40px;
  //   // top: calc(40px + env(safe-area-inset-top));
  //   left: 0;
  //   text-align: center;
  //   line-height: 44px;
  //   font-weight: 600;
  //   color: #112a26;
  //   font-size: 0.9rem;
  //   .back {
  //     position: absolute;
  //     width: 0.6rem;
  //     height: 1.2rem;
  //     left: 0.8rem;
  //     top: 0.5rem;
  //   }
  // }

  .content_dialog {
    padding: 1.6rem;
    font-size: 0.7rem;
    color: #212121;
    line-height: 1rem;
    .rules {
      font-weight: 600;
      color: #a97048;
    }
  }

  .swiper {
    width: 100%;
    height: 14.1rem;
    .back {
      z-index: 1;
      position: absolute;
      width: 0.6rem;
      height: 1.2rem;
      left: 0.8rem;
      top: 48px;
      // top: calc(40px + env(safe-area-inset-top));
    }
    .swiper_img {
      width: 100%;
      height: 14.1rem;
    }
    .custom-indicator {
      position: absolute;
      height: 0.95rem;
      line-height: 0.95rem;
      right: 8px;
      bottom: 0.95rem;
      padding: 0 9px;
      font-size: 0.6rem;
      background: rgba(0, 0, 0, 0.5);
      color: #fff;
      border-radius: 0.5rem;
    }
  }
  .common_title {
    font-size: 0.9rem;
    font-weight: 600;
    color: #212121;
    line-height: 1.4rem;
  }

  .sub_title {
    margin: 0.4rem 0 0.6rem 0;
    font-size: 0.6rem;
    :first-child {
      display: inline-block;
      padding: 0 0.3rem;
      // color: #47988aff;
      color: #a97048;
      height: 0.9rem;
      line-height: 0.9rem;
      // background: rgba(223, 242, 242, 0.5);
      background: #f8e8d5;
      border-radius: 2px;
      margin-right: 0.4rem;
    }
    :last-child {
      font-size: 0.6rem;
      color: #666666;
      line-height: 0.8rem;
    }
  }
  .main_card {
    position: absolute;
    top: 13.75rem;
    left: 0;
    width: 100%;
    background: #fff;
    border-radius: 8px 8px 0px 0px;
    padding: 0.8rem 0.6rem 2.5rem 0.6rem;
    &::before {
      content: '';
      display: inline-block;
      width: 2rem;
      height: 5px;
      background: #cccc;
      border-radius: 3px;
      position: absolute;
      left: calc(50% - 1rem);
      top: 0.6rem;
    }

    // width: 100%;
    // height: calc(100% - 84px);
    // position: absolute;
    // top: 84px;
    // left: 0;
    // padding: 0.4rem 0.6rem 0 0.6rem;
    // padding-bottom: calc(5rem + env(safe-area-inset-bottom));

    .card_detail {
      .pic_box {
        position: relative;
        .pic_url {
          width: 4.8rem;
          height: 6.4rem;
          margin-right: 0.6rem;
          border-radius: 0.5rem;
        }
        .view_box {
          z-index: 11;
          position: absolute;
          left: 0.4rem;
          bottom: 0.3rem;
          font-size: 0.6rem;
          color: #ffffff;
          .eye_icon {
            width: 0.6rem;
            height: 0.6rem;
            margin-right: 0.2rem;
          }
        }
      }
    }
    .card_info {
      margin-top: 0.8rem;
      padding-bottom: 0.8rem;
      border-bottom: 1px solid #f4f4f4;
      .info_item {
        height: 1.2rem;
        line-height: 1.2rem;
        // margin-bottom: 0.2rem;
        img {
          width: 0.7rem;
          height: 0.7rem;
          margin-right: 0.2rem;
        }
        .icon {
          margin-left: 0.6rem;
          width: 1.2rem;
          height: 1.2rem;
        }
        div {
          color: #666666;
          line-height: 16px;
          font-size: 0.6rem;
        }
      }
    }
    .tips,
    .event_profile {
      margin-top: 0.75rem;
      .content {
        margin-top: 0.6rem;
        font-size: 0.7rem;
        color: #666666;
        line-height: 1rem;
        display: -webkit-box; //
        -webkit-box-orient: vertical; //设置弹性盒子的子元素的排列方式
      }
    }
  }
  .handle_button {
    position: fixed;
    bottom: 0;
    left: 0;
    height: 2.9rem;
    width: 100%;
    background: #fff;
    padding: 0 0.6rem 0 0.6rem;
    font-size: 0.7rem;
    // color: #47988a;

    color: #a97048;
    line-height: 1rem;
    padding-bottom: calc(0.6rem + env(safe-area-inset-bottom));
    .handle_item {
      &.border_right {
        padding-right: 0.6rem;
        // position: relative;
        // ::after {
        //   position: absolute;
        //   content: '';
        //   display: inline-block;
        //   width: 1px;
        //   height: 0.7rem;
        //   top: 0.35rem;
        //   right: 0;
        //   background: #47988a;
        // }
      }
      &.border_left {
        padding-left: 0.6rem;
      }
      .icon_handle {
        width: 1.4rem;
        height: 1.4rem;
        margin-right: 0.2rem;
      }
    }
    .btn,
    .disabled {
      width: 13.75rem;
      text-align: center;
      height: 1.8rem;
      line-height: 1.8rem;
      // background: #47988a;

      background: #a97048;
      border-radius: 0.9rem;
      font-size: 0.7rem;
      color: #ffffff;
    }
    .disabled {
      color: #ffffff;
      background: #cccccc;
    }
  }
}
</style>
